export interface Fond {
  fondName?: string;
  id?: string;
  isin?: string;
  holdingPeriod?: string;
  chartView?: string;
}

export interface FondCollectionItem {
  fondName: string;
  isin: string;
  holdingPeriod: string;
}

export enum ChartView {
  Comparison = 'comparison',
  Chart = 'chart',
  Calculator = 'calculator',
}
